import * as React from 'react';

import { useSetAtom } from 'jotai';

import { $brokeredLoadCreateForm } from '../_state/brokeredLoadCreateForm.state';
import { BrokeredLoadFormLineItem } from '../types/brokeredLoad';

import { createDefaultBrokeredLoadLineItem } from './useBrokeredLoadLineItemsManager';

export const useBrokeredLoadCreateLineItemsManager = () => {
  const updateForm = useSetAtom($brokeredLoadCreateForm);

  const updateItem = React.useCallback(
    (id: string, updates: Partial<BrokeredLoadFormLineItem>) => {
      updateForm((prevForm) => {
        const lineItems = prevForm.lineItems.map((line) => {
          if (line.id === id) {
            return { ...line, ...updates };
          }
          return line;
        });
        return { ...prevForm, lineItems };
      });
    },
    [updateForm],
  );

  const addItem = React.useCallback(
    (data?: Partial<BrokeredLoadFormLineItem>) => {
      const newItem = createDefaultBrokeredLoadLineItem(data);
      updateForm((prevForm) => ({
        ...prevForm,
        lineItems: [...prevForm.lineItems, newItem],
      }));
      return newItem.id;
    },
    [updateForm],
  );

  const addItems = React.useCallback(
    (items: Partial<BrokeredLoadFormLineItem>[]) => {
      const newItems = items.map((data) =>
        createDefaultBrokeredLoadLineItem(data),
      );
      updateForm((prevForm) => ({
        ...prevForm,
        lineItems: [...prevForm.lineItems, ...newItems],
      }));
      return newItems.map((item) => item.id);
    },
    [updateForm],
  );

  const deleteItem = React.useCallback(
    (id: string) => {
      updateForm((prevForm) => {
        const lineItems = prevForm.lineItems.filter((line) => line.id !== id);
        return { ...prevForm, lineItems };
      });
    },
    [updateForm],
  );

  return {
    updateItem,
    addItem,
    addItems,
    deleteItem,
  };
};
